var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6 text-center text-sm-left"},[_c('p',[_vm._v("© Copyright "+_vm._s(new Date().toISOString().slice(0, 4))+". All rights reserved.")])]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col col-sm-6 ml-sm-auto text-center text-sm-right"},[_c('p',[_vm._v(" Model Softplus Limited ")])])
}]

export { render, staticRenderFns }